<form
  [formGroup]="form"
  class="form-b4a try-on-form"
  (submit)="submit()"
  *ngIf="loaded"
>
  <p-fieldset legend="Prova virtual (MaIA Try-On)">
    <span class="p-float-label">
      <p-dropdown
        formControlName="category"
        inputId="tryOnCategory"
        [options]="categoryOptions"
        optionValue="value"
        optionLabel="name"
        appendTo="body"
        [showClear]="true"
        placeholder="Selecione"
      />
      <label for="tryOnCategory">Categoria da prova virtual</label>
    </span>
    <span class="p-float-label">
      <input
        id="tryOnDisclaimer"
        pInputText
        formControlName="disclaimer"
        maxlength="240"
        [placeholder]="defaultDisclaimer"
      />
      <label for="tryOnDisclaimer">Aviso exibido na PDP (opcional)</label>
    </span>
    <span class="p-input-checkbox try-on-form__toggle">
      <p-checkbox
        formControlName="enabled"
        [binary]="true"
        inputId="tryOnEnabled"
      />
      <label for="tryOnEnabled"
        >Exibir prova virtual na página do produto</label
      >
      <small class="error" *ngIf="blockReason">
        {{ blockReason }}
        <ng-container *ngIf="isEnableBlocked">
          Corrija os tons ou desmarque a exibição para salvar.
        </ng-container>
      </small>
    </span>
    <span class="p-float-label" *ngIf="isModeVisible">
      <p-dropdown
        formControlName="mode"
        inputId="tryOnMode"
        [options]="modeOptions"
        optionValue="value"
        optionLabel="name"
        appendTo="body"
      />
      <label for="tryOnMode">Modo da prova virtual</label>
      <small class="try-on-form__meta">
        "Ao vivo" usa a câmera em tempo real; "Foto" usa a foto enviada pela
        cliente. "Foto e ao vivo" oferece os dois na página do produto.
      </small>
      <small class="try-on-form__meta" *ngIf="isLiveOnlyCategory">
        Esta categoria só é renderizada ao vivo; a prova por foto atende apenas
        base e batom.
      </small>
    </span>
    <small class="try-on-form__meta" *ngIf="productUpdatedAt">
      Produto alterado em {{ productUpdatedAt | date: 'dd/MM/yyyy HH:mm' }}
    </small>
  </p-fieldset>

  <p-fieldset legend="Tons (variantes)" *ngIf="hasVariants">
    <p *ngIf="!rows.length" class="try-on-form__empty">
      Este produto não possui variantes cadastradas.
    </p>
    <small class="try-on-form__meta" *ngIf="staleShadeCount">
      Este produto possui {{ staleShadeCount }} tom(ns) de paleta
      (try_on_shades) que serão removidos ao salvar: produtos com variantes usam
      os tons das variantes.
    </small>
    <div class="try-on-form__rows" formArrayName="rows">
      <div
        class="try-on-form__row"
        *ngFor="let row of rows.controls; let i = index"
        [formGroupName]="i"
      >
        <div class="try-on-form__row-header">
          <span
            class="try-on-form__swatch"
            [style.background]="row.controls.color.value || 'transparent'"
            [class.try-on-form__swatch--empty]="!row.controls.color.value"
            aria-hidden="true"
          ></span>
          <strong>{{ row.controls.label.value }}</strong>
          <small *ngIf="row.controls.updatedAt.value">
            alterado em
            {{ row.controls.updatedAt.value | date: 'dd/MM/yyyy HH:mm' }}
          </small>
        </div>

        <div class="try-on-form__row-fields">
          <span class="p-float-label try-on-form__color">
            <input
              type="color"
              class="try-on-form__picker"
              [id]="'tryOnPicker' + i"
              [value]="row.controls.color.value || '#000000'"
              [disabled]="row.controls.color.disabled"
              (change)="onPickerChange(i, $event)"
              [attr.aria-label]="'Seletor de cor ' + row.controls.label.value"
            />
            <input
              [id]="'tryOnColor' + i"
              pInputText
              formControlName="color"
              maxlength="7"
              placeholder="#RRGGBB"
              (blur)="onHexBlur(i, $event)"
            />
            <label [for]="'tryOnColor' + i">Cor (hex)</label>
            <small class="error" *ngIf="hexErrors[i]">
              Cor inválida: use o formato #RRGGBB.
            </small>
          </span>

          <span class="p-float-label" *ngIf="isFinishVisible">
            <p-dropdown
              formControlName="finish"
              [inputId]="'tryOnFinish' + i"
              [options]="finishOptions"
              optionValue="value"
              optionLabel="name"
              appendTo="body"
              [showClear]="true"
              placeholder="Selecione"
            />
            <label [for]="'tryOnFinish' + i">Acabamento</label>
          </span>

          <span class="p-float-label try-on-form__intensity">
            <p-slider
              formControlName="intensity"
              [min]="intensityMin"
              [max]="intensityMax"
              [step]="1"
            />
            <p-inputNumber
              formControlName="intensity"
              [inputId]="'tryOnIntensity' + i"
              [min]="intensityMin"
              [max]="intensityMax"
              [showButtons]="true"
              [useGrouping]="false"
            />
            <label [for]="'tryOnIntensity' + i">Intensidade (0–100)</label>
          </span>

          <span class="p-float-label">
            <p-dropdown
              formControlName="calibration"
              [inputId]="'tryOnCalibration' + i"
              [options]="calibrationOptions"
              optionValue="value"
              optionLabel="name"
              appendTo="body"
              [showClear]="true"
              placeholder="Selecione"
            />
            <label [for]="'tryOnCalibration' + i">Calibração da cor</label>
          </span>

          <span class="p-input-checkbox" *ngIf="hasVariants">
            <p-checkbox
              formControlName="enabled"
              [binary]="true"
              [inputId]="'tryOnRowEnabled' + i"
            />
            <label [for]="'tryOnRowEnabled' + i">Tom habilitado</label>
          </span>
        </div>

        <ul class="try-on-form__errors" *ngIf="rowErrors[i]?.length">
          <li *ngFor="let error of rowErrors[i]">{{ error }}</li>
        </ul>
      </div>
    </div>
  </p-fieldset>

  <p-fieldset legend="Tons" *ngIf="isShadesVisible">
    <small class="try-on-form__meta">
      Produto de cor única: um tom (o nome é opcional). Paleta: adicione os
      demais tons. Cada tom vira uma opção na prova virtual, na ordem da lista;
      nomes únicos. Máximo de {{ shadesMax }} tons.
    </small>
    <p *ngIf="!shades.length" class="try-on-form__empty">
      Nenhum tom cadastrado. Adicione ao menos um tom para exibir a prova
      virtual.
    </p>
    <ul class="try-on-form__errors" *ngIf="shadesListErrors.length">
      <li *ngFor="let error of shadesListErrors">{{ error }}</li>
    </ul>
    <div class="try-on-form__rows" formArrayName="shades">
      <div
        class="try-on-form__row"
        *ngFor="let shade of shades.controls; let i = index"
        [formGroupName]="i"
      >
        <div class="try-on-form__row-header">
          <span
            class="try-on-form__swatch"
            [style.background]="shade.controls.color.value || 'transparent'"
            [class.try-on-form__swatch--empty]="!shade.controls.color.value"
            aria-hidden="true"
          ></span>
          <strong>{{ shade.controls.name.value || 'Tom ' + (i + 1) }}</strong>
          <p-button
            *ngIf="permission"
            type="button"
            icon="pi pi-trash"
            severity="danger"
            [text]="true"
            [rounded]="true"
            [attr.aria-label]="'Remover tom ' + (i + 1)"
            (onClick)="removeShade(i)"
          />
        </div>

        <div class="try-on-form__row-fields">
          <span class="p-float-label try-on-form__shade-name">
            <input
              [id]="'tryOnShadeName' + i"
              pInputText
              formControlName="name"
              [maxlength]="shadeNameMax"
              [placeholder]="'Tom ' + (i + 1)"
            />
            <label [for]="'tryOnShadeName' + i">
              Nome do tom{{ isShadeNameRequired ? '' : ' (opcional)' }}
            </label>
          </span>

          <span class="p-float-label try-on-form__color">
            <input
              type="color"
              class="try-on-form__picker"
              [id]="'tryOnShadePicker' + i"
              [value]="shade.controls.color.value || '#000000'"
              [disabled]="shade.controls.color.disabled"
              (change)="onShadePickerChange(i, $event)"
              [attr.aria-label]="'Seletor de cor do tom ' + (i + 1)"
            />
            <input
              [id]="'tryOnShadeColor' + i"
              pInputText
              formControlName="color"
              maxlength="7"
              placeholder="#RRGGBB"
              (blur)="onShadeHexBlur(i, $event)"
            />
            <label [for]="'tryOnShadeColor' + i">Cor (hex)</label>
            <small class="error" *ngIf="shadeHexErrors[i]">
              Cor inválida: use o formato #RRGGBB.
            </small>
          </span>

          <span class="p-float-label" *ngIf="isFinishVisible">
            <p-dropdown
              formControlName="finish"
              [inputId]="'tryOnShadeFinish' + i"
              [options]="finishOptions"
              optionValue="value"
              optionLabel="name"
              appendTo="body"
              [showClear]="true"
              placeholder="Selecione"
            />
            <label [for]="'tryOnShadeFinish' + i">Acabamento</label>
          </span>

          <span class="p-float-label try-on-form__intensity">
            <p-slider
              formControlName="intensity"
              [min]="intensityMin"
              [max]="intensityMax"
              [step]="1"
            />
            <p-inputNumber
              formControlName="intensity"
              [inputId]="'tryOnShadeIntensity' + i"
              [min]="intensityMin"
              [max]="intensityMax"
              [showButtons]="true"
              [useGrouping]="false"
            />
            <label [for]="'tryOnShadeIntensity' + i">Intensidade (0–100)</label>
          </span>

          <span class="p-float-label">
            <p-dropdown
              formControlName="calibration"
              [inputId]="'tryOnShadeCalibration' + i"
              [options]="calibrationOptions"
              optionValue="value"
              optionLabel="name"
              appendTo="body"
              [showClear]="true"
              placeholder="Selecione"
            />
            <label [for]="'tryOnShadeCalibration' + i">Calibração da cor</label>
          </span>
        </div>

        <ul class="try-on-form__errors" *ngIf="shadeErrors[i]?.length">
          <li *ngFor="let error of shadeErrors[i]">{{ error }}</li>
        </ul>
      </div>
    </div>
    <div class="try-on-form__shade-actions" *ngIf="permission">
      <p-button
        type="button"
        label="Adicionar tom"
        icon="pi pi-plus"
        [outlined]="true"
        [disabled]="!canAddShade"
        (onClick)="addShade()"
      />
      <small class="try-on-form__meta" *ngIf="shades.length >= shadesMax">
        Limite de {{ shadesMax }} tons atingido.
      </small>
    </div>
  </p-fieldset>

  <div class="buttons" *ngIf="permission">
    <p-button
      type="submit"
      label="Salvar prova virtual"
      icon="pi pi-save"
      [disabled]="!canSubmit"
    />
  </div>
</form>
